import { cn } from '@verlo/shared/lib/utils';

/**
 * A titled white section on a page (Back office sweep, Oct 2026): a Manrope title, a line
 * saying what it's for, an action on the right, and its contents under a hairline.
 *
 *   <Panel title="Running low" purpose="Below their low mark." right={<Button>Order these</Button>}>…</Panel>
 */
const Panel = ({ title, purpose, right, children, className, testId }) => (
  <section className={cn('rounded-lg border border-hairline bg-white', className)} data-testid={testId}>
    <div className="flex flex-wrap items-start justify-between gap-3 border-b border-hairline px-5 py-4">
      <div className="min-w-0">
        <h2 className="font-heading text-[16px] font-extrabold text-ink">{title}</h2>
        {purpose && <p className="mt-0.5 max-w-2xl text-[13px] text-ink-soft">{purpose}</p>}
      </div>
      {right}
    </div>
    {children}
  </section>
);

export default Panel;
